import 'angular:locale/data:sv';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "sv";
